import React, { useState } from 'react';
import { X } from 'lucide-react';
import { Button } from '../ui/Button';
import { Input } from '../ui/Input';

interface Props {
  count: number;
  onClear: () => void;
  onApplyBulkPrice: (basePrice: number) => Promise<void>;
  loading: boolean;
}

export function BulkPriceBar({ count, onClear, onApplyBulkPrice, loading }: Props) {
  const [price, setPrice] = useState('');

  const handleApply = async () => {
    const num = parseFloat(price);
    if (isNaN(num) || num < 0) return;
    await onApplyBulkPrice(num);
    setPrice('');
  };

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      gap: '0.75rem',
      padding: '0.75rem 1rem',
      background: 'var(--color-primary-highlight)',
      border: '1px solid var(--color-primary)',
      borderRadius: 'var(--radius-card)',
      flexWrap: 'wrap',
    }}>
      <span style={{ fontSize: 'var(--text-sm)', fontWeight: 600, color: 'var(--color-text)' }}>
        {count} prodotti selezionati
      </span>
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', flex: 1, flexWrap: 'wrap' }}>
        <Input
          type="number"
          min="0"
          step="0.01"
          placeholder="Nuovo prezzo"
          value={price}
          onChange={e => setPrice(e.target.value)}
          disabled={loading}
          style={{ maxWidth: 140 }}
        />
        <Button
          size="sm"
          onClick={handleApply}
          loading={loading}
          disabled={!price || parseFloat(price) < 0}
        >
          Applica prezzo
        </Button>
      </div>
      <button
        onClick={onClear}
        disabled={loading}
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          padding: '0.25rem',
          color: 'var(--color-text-muted)',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <X size={16} />
      </button>
    </div>
  );
}
